import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jiacu",
  "use": "icon-jiacu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-jiacu\"><path d=\"M341.333333 469.333333h192a106.666667 106.666667 0 1 0 0-213.333333H341.333333v213.333333z m426.666667 192a192 192 0 0 1-192 192H256V170.666667h277.333333a192 192 0 0 1 138.922667 324.522666A191.914667 191.914667 0 0 1 768 661.333333zM341.333333 554.666667v213.333333h234.666667a106.666667 106.666667 0 1 0 0-213.333333H341.333333z\" p-id=\"2081\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol